/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { StatusWithRelations } from './statusWithRelations';
import { RelationsWithRelations } from './relationsWithRelations';
import { SurveyResponsesWithRelations } from './surveyResponsesWithRelations';
import { RelationTypesWithRelations } from './relationTypesWithRelations';


/**
 * (tsType: SurveysWithRelations, schemaOptions: { includeRelations: true })
 */
export interface SurveysWithRelations { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: string;
    isCustom?: boolean;
    evaluationId: string;
    relationId?: string;
    customRelationTypeId?: object;
    statusId?: string;
    relations?: RelationsWithRelations;
    relationTypes?: RelationTypesWithRelations;
    status?: StatusWithRelations;
    surveyResponses?: Array<SurveyResponsesWithRelations>;
}

